const PlayIconFilled = ({ onClick }: { onClick: () => void }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    onClick={onClick}
  >
    <path
      d="M20.6203 39.9805C23.3524 39.9805 25.9243 39.4578 28.336 38.4125C30.7478 37.3674 32.8753 35.9236 34.7183 34.0813C36.5615 32.2392 38.006 30.1128 39.0516 27.7021C40.0975 25.2916 40.6204 22.721 40.6204 19.9902C40.6204 17.2595 40.0975 14.6889 39.0516 12.2783C38.006 9.86773 36.5615 7.74132 34.7183 5.89907C32.8753 4.05684 30.7445 2.6131 28.3262 1.56786C25.9079 0.52262 23.3328 0 20.6007 0C17.8687 0 15.2968 0.52262 12.8851 1.56786C10.4733 2.6131 8.34911 4.05684 6.51251 5.89907C4.67591 7.74132 3.23474 9.86773 2.18899 12.2783C1.14324 14.6889 0.620361 17.2595 0.620361 19.9902C0.620361 22.721 1.14324 25.2916 2.18899 27.7021C3.23474 30.1128 4.67918 32.2392 6.52231 34.0813C8.36545 35.9236 10.4929 37.3674 12.9047 38.4125C15.3164 39.4578 17.8883 39.9805 20.6203 39.9805Z"
      fill="white"
    />
    <path
      d="M17.9385 26.5269C17.544 26.7678 17.1633 26.8088 16.7962 26.65C16.4291 26.4912 16.2456 26.2092 16.2456 25.804V14.0253C16.2456 13.6201 16.4374 13.3463 16.8209 13.2039C17.2044 13.0616 17.5769 13.0944 17.9385 13.3025L27.6028 19.0194C27.9424 19.2274 28.115 19.5286 28.1205 19.9229C28.126 20.3172 27.9534 20.6239 27.6028 20.8429L17.9385 26.5269Z"
      fill="black"
    />
  </svg>
);
export default PlayIconFilled;
